<script lang="ts">
	export { classes as class };
	let classes = '';
</script>

<div class="w-full py-1.5 {classes}">
	<div class="h-2px w-full bg-c-bg-tertiary" />
</div>
